import PropTypes from 'prop-types';
import { Flex, Grid, jsx } from 'theme-ui';
import { FormattedMessage } from 'gatsby-plugin-react-intl';
/** @jsx jsx */
import { graphql } from 'gatsby';

import Button from '../shared/Buttons';
import InterfaceContext from '../../context/InterfaceContext';
import ProductListingItem from './ProductListingItem';

const ProductListing = ({ className, featured, products, shopifyProducts }) => {
  let filtered = [];

  filtered = products.nodes.map((node) => ({
    id: node.id,
    ...node.frontmatter,
    ...shopifyProducts.nodes.find((p) => p.handle === node.frontmatter.handle),
  }));

  // Clean up products without images and variants
  filtered = filtered.filter((p) => p.images != null && p.images.length > 0);
  filtered = filtered.filter((p) => p.variants && p.variants.length === 1);
  filtered = filtered.reverse();

  if (featured) {
    filtered = filtered.slice(0, 8);
  }

  const productListingItems = filtered.map((product) => (
    <ProductListingItem key={product.id} product={product} />
  ));

  return (
    <InterfaceContext.Consumer>
      {({ isDesktopViewport }) => (
        <div className={className} sx={{ textAlign: 'center' }}>
          {isDesktopViewport ? (
            <Grid
              gap={4}
              width="26rem"
              sx={{
                justifyItems: 'center',
              }}
            >
              {productListingItems}
            </Grid>
          ) : (
            <Flex
              flexWrap="nowrap"
              sx={{
                WebkitOverflowScrolling: 'touch',
                overflowX: 'auto',
                '& > *': { flex: '0 0 26rem' },
                '&::-webkit-scrollbar': { display: 'none' },
                maxWidth: '100vw',
              }}
            >
              {productListingItems}
            </Flex>
          )}
          {featured && (
            <Button variant="primary" to="/products">
              <FormattedMessage id="productListing.viewAllProducts" />
            </Button>
          )}
        </div>
      )}
    </InterfaceContext.Consumer>
  );
};

ProductListing.propTypes = {
  className: PropTypes.string,
  featured: PropTypes.bool,
  products: PropTypes.object,
  shopifyProducts: PropTypes.object,
};

export default ProductListing;

export const query = graphql`
  fragment ProductListing on Query {
    products: allMdx(
      filter: {
        frontmatter: {
          categoryHandle: { regex: $categoryHandle }
          handle: { ne: null }
          locale: { eq: $locale }
        }
      }
    ) {
      nodes {
        id
        frontmatter {
          categoryHandle
          handle
          title
          story
          images {
            altText
            localFile {
              id
              childImageSharp {
                gatsbyImageData(width: 320, height: 320, placeholder: TRACED_SVG)
              }
            }
          }
        }
      }
    }
    shopifyProducts: allShopifyProduct(sort: { fields: [publishedAt], order: ASC }) {
      nodes {
        ...ProductListingItem
      }
    }
  }
`;
